<template>
  <button
    id="goToTop"
    @click="goTop()"
  >
    <i class="fas fa-arrow-up" />
  </button>
</template>

<script>
import $ from 'jquery'
export default {
  data () {
    return {
    }
  },
  created () {
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $('#goToTop').stop(true, true).fadeIn('slow')
      } else {
        $('#goToTop').stop(true, true).fadeOut('slow')
      }
    })
  },

  methods: {
    goTop () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style scoped lang="scss">
#goToTop {
    max-width: 2em;
    max-height: 2em;
    display: none;
    position: fixed;
    opacity: 0.6;
    top: 60px;
    right: 30px;
    z-index: 999999;
    font-size: 18px;
    border: none;
    outline: none;
    background-color: #f79000;
    color: white;
    cursor: pointer;
    padding: 2px 13px 6px 10px;
    border-radius: 50%;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    transition: all 0.3s cubic-bezier(.25,.8,.25,1);
}

#goToTop:hover {
    opacity: 1;
    background-color: #f7a733;
}

</style>
